import { sendGrantFromRow } from './sendGrantMapper'

/** Map a do-chat-api workflow definition row to the UI shape. */
export function workflowFromRow(row = {}) {
  return {
    id: String(row.workflow_id ?? row.id ?? ''),
    title: String(row.title || 'Untitled workflow'),
    description: String(row.description || ''),
    // The chat the workflow was created from — how a thread earns its badge.
    conversationId: row.source_conversation_id ? String(row.source_conversation_id) : null,
    status: String(row.status || 'active'),
    kind: String(row.kind || 'research'),
    // The *whole* spec, not just the goal. PATCH replaces this object wholesale,
    // so editing the prompt means resending everything else it carried —
    // `instruction` (required for kind='download') and `source_workflow_id`.
    spec: row.spec && typeof row.spec === 'object' ? row.spec : {},
    cron: row.cron ?? null,
    timezone: row.timezone ?? null,
    scheduleEnabled: Boolean(row.schedule_enabled),
    // Always null: n8n owns the clock, so the row carries no due time.
    nextRunAt: row.next_run_at ?? null,
    lastRunAt: row.last_run_at ?? null,
    // Null unless this workflow may send unattended. See sendGrantMapper.
    sendGrant: sendGrantFromRow(row),
  }
}

/**
 * "Has an active trigger or schedule". Both signals are accepted because
 * `schedule_enabled` is what n8n reconciles against while `cron` is what a
 * paused-but-configured workflow still carries.
 */
export function isWorkflowScheduled(workflow) {
  if (!workflow || workflow.status !== 'active') return false
  return Boolean(workflow.scheduleEnabled || workflow.cron)
}
